// Axios and configuration
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import { I_ApprovalStep } from "../interfaces";

// Utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Fetches the list of approval steps for a specific record and record type.
 *
 * @param recordTypeId - Identifier for the type of record (e.g., incident, form)
 * @param recordId - Unique identifier of the record to get approval steps for
 * @returns An array of approval steps, or an empty array on failure
 */
const GetApprovalStatus = async (
  recordTypeId: number,
  recordId: number
): Promise<I_ApprovalStep[]> => {
  try {
    const response = await Axios.get<I_BaseAPIResponse<I_ApprovalStep[]>>(
      `${process.env.REACT_APP_API_URL}/api/approval/status?recordTypeId=${recordTypeId}&recordId=${recordId}`,
      AxiosConfig.configValue("min")
    );

    if (response.data.HasError) {
      snackBar({
        type: "error",
        text: response.data.ErrorMessage,
        timeout: 4000,
      });
      return [];
    }

    return response.data.Data;
  } catch (error) {
    console.error("GetApprovalStatus failed:", error);
    snackBar({
      type: "error",
      text: "Failed to get approval status",
      timeout: 4000,
    });
    return [];
  }
};

export default GetApprovalStatus;
